import React, { useState, useEffect, useRef, useMemo } from "react";
import { Popover } from "@material-ui/core";
import { useConfigs } from "../config-provider";
import Calendar from "./Calendar";
import Dropdown from "../dropdown";
import List from "../pro-select/List";
import { useControlled } from "../utils";
import { getStartAndEndTime } from "./utils";

var DateRange = function DateRange(_a) {
  var label = _a.label,
      preLabel = _a.preLabel,
      timeDisable = _a.timeDisable,
      rangeValid = _a.rangeValid,
      hasNoYear = _a.hasNoYear,
      defaultValue = _a.value,
      onChange = _a.onChange;
  var configs = useConfigs();
  var locale = configs.locale;
  var textRef = useRef(null);

  var _b = useState(false),
      open = _b[0],
      setOpen = _b[1];

  var _c = useState(false),
      listOpen = _c[0],
      setListOpen = _c[1];

  var _d = useControlled({
    controlled: defaultValue,
    default: {
      type: "customized",
      range: [null, null],
      hasTime: false
    }
  }),
      value = _d[0],
      setValue = _d[1];

  var _e = useState(1),
      refresh = _e[1];

  var options = React.useMemo(function () {
    return hasNoYear ? [{
      value: "oneHour",
      label: locale.DateRange.oneHour
    }, {
      value: "today",
      label: locale.DateRange.today
    }, {
      value: "oneWeek",
      label: locale.DateRange.oneWeek
    }, {
      value: "oneMonth",
      label: locale.DateRange.oneMonth
    }, {
      value: "customized",
      label: locale.DateRange.customized
    }] : [{
      value: "oneHour",
      label: locale.DateRange.oneHour
    }, {
      value: "today",
      label: locale.DateRange.today
    }, {
      value: "oneWeek",
      label: locale.DateRange.oneWeek
    }, {
      value: "oneMonth",
      label: locale.DateRange.oneMonth
    }, {
      value: "oneYear",
      label: locale.DateRange.oneYear
    }, {
      value: "customized",
      label: locale.DateRange.customized
    }];
  }, [hasNoYear, locale]);
  var textValue = useMemo(function () {
    if (value && value.type !== "customized") {
      var selected = options.find(function (item) {
        return item.value === value.type;
      });
      return selected && selected.label || "";
    } else if (value && value.type === "customized" && value.range && value.range.some(function (item) {
      return item === null;
    })) {
      return "";
    } else if (value && value.type === "customized" && Array.isArray(value.range)) {
      return value.range.map(function (item) {
        return item && item.format(value.hasTime ? "M/D/YYYY hh:mm A" : "M/D/YYYY");
      }).join("~");
    }

    return "";
  }, [value]);
  useEffect(function () {
    refresh(0);
  }, []);

  function handleClose() {
    setOpen(false);
  }

  function handleChange(range, hasTime) {
    var newValue = {
      type: "customized",
      range: range,
      hasTime: hasTime
    };
    onChange && onChange(newValue);
    setOpen(false);
    setValue(newValue);
  }

  function handleListChange(selItem) {
    setListOpen(false);

    if (selItem.value === "customized") {
      setOpen(true);
    } else {
      var newValue = {
        type: selItem.value,
        range: getStartAndEndTime(selItem.value)
      };
      setValue(newValue);
      onChange && onChange(newValue);
    }
  }

  return React.createElement("div", null, React.createElement("div", {
    ref: textRef
  }, React.createElement(Dropdown, {
    preLabel: preLabel,
    label: label,
    open: listOpen || open,
    value: textValue,
    onClick: function onClick() {
      return setListOpen(true);
    },
    onClear: function onClear() {
      return handleChange([null, null]);
    }
  })), open && textRef && textRef.current && React.createElement(Popover, {
    open: true,
    anchorEl: textRef.current,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    onClose: function onClose() {
      return setOpen(false);
    }
  }, React.createElement(Calendar, {
    value: value.range || [null, null],
    timeDisable: timeDisable,
    rangeValid: rangeValid,
    onChange: handleChange,
    onClose: handleClose,
    hasTime: value.hasTime
  })), listOpen && textRef && textRef.current && React.createElement(Popover, {
    open: true,
    anchorEl: textRef.current,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    onClose: function onClose() {
      return setListOpen(false);
    }
  }, options.length === 0 ? locale.DateRange.noData : React.createElement(List, {
    options: options,
    selected: value && value.type,
    onChange: handleListChange
  })));
};

export default DateRange;